<template>
  <div class="index-banner-home" v-if="shouldShowBanner">
    <div
      class="carousel"
      @mousedown.stop="startDrag"
      @mouseup.stop="endDrag"
      @mouseleave.stop="endDrag"
      @wheel.passive="handleWheel"
      @touchstart.stop="startDrag"
      @touchmove.stop="drag"
      @touchend.stop="endDrag"
    >
      <div
        class="carousel-slides"
        ref="slides"
        @mousemove.stop="drag"
        @touchmove.stop="drag"
      >
        <div
          v-for="(slide, index) in homeBannerList"
          :key="index"
          class="carousel-slide"
        >
          <div class="banner-bg-wrapper" v-if="slide.video">
            <video
              :controls="false"
              class="video"
              :ref="`vueMiniPlayer${index}`"
              :playsinline="true"
              @play="
                videoIsPlay = true;
                videoPaused = false;
              "
              @pause="
                videoIsPlay = false;
                videoPaused = true;
              "
              @ended="onVideoEnded"
              @timeupdate="updateProgress"
              @loadedmetadata="
                duration = $refs[`vueMiniPlayer${index}`][0].duration
              "
              @mousemove="handleMouseMove"
              @mouseleave="handleMouseLeave"
              @touchstart="handleTouchStart"
              @touchmove="handleTouchMove"
              @touchend="handleTouchEnd"
              @click="handleVideoClick"
            >
              <source :src="slide.video" type="video/mp4" />
              您的浏览器不支持Video标签。
            </video>
            <!-- 视频封面图 -->
            <img
              v-if="(!videoIsPlay || videoPaused) && getVideoCoverImage(slide)"
              :src="getVideoCoverImage(slide)"
              class="overlay-image"
              alt="视频封面"
            />
          </div>
          <div
            class="imgShow"
            v-else
            @mousedown.stop.prevent="startDrag"
            @mouseup.stop.prevent="endDrag"
          >
            <img class="pc" v-if="!isIndex" :src="slide.img" alt="" />
            <img class="wap" v-else :src="slide.img" alt="" />
          </div>
        </div>
      </div>
    </div>

    <!-- 视频播放控制区域 -->
    <div
      class="video-box"
      v-show="controlsVisible"
      @mousemove="handleMouseMove"
      @mouseleave="handleMouseLeave"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div class="video-controls" v-if="homeBannerList[currentIndex]?.video">
        <div class="progress-container">
          <div
            class="progress-bar"
            @click="seekVideo"
            @mousedown.stop="startProgressDrag"
            @touchstart.stop="startProgressDrag"
          >
            <div class="progress" :style="{ width: `${progress}%` }"></div>
          </div>
          <div class="volume-control">
            <div class="play-pause-control">
              <button @click="toggleVideo" class="play-pause-button">
                <img
                  v-if="!videoIsPlay"
                  src="../../assets/videoPlay.png"
                  alt="播放"
                />
                <img v-else src="../../assets/videoPaused.png" alt="暂停" />
              </button>
            </div>
            <div class="time-display">
              {{ currentTime | formatTime }} / {{ duration | formatTime }}
            </div>
            <button @click="toggleMute" class="mute-button">
              <img
                v-if="!isMuted"
                src="../../assets/icon_volume_1.png"
                alt="音量开启"
              />
              <img v-else src="../../assets/icon_volume_2.png" alt="音量关闭" />
            </button>
            <!-- 自定义音量滑块 -->
            <div
              class="custom-volume-slider"
              ref="volumeSlider"
              @mousedown.stop="startVolumeDrag"
              @click.stop="adjustVolumeByClick"
            >
              <div class="volume-track"></div>
              <div class="volume-progress" ref="volumeProgress"></div>
              <div class="volume-thumb" ref="volumeThumb"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-swiper-pagination">
      <div
        class="carousel-pagination"
        v-if="bannerData && bannerData.length > 1 && !videoIsPlay"
      >
        <div
          v-for="(_, index) in bannerData"
          :key="_.id"
          :class="{
            'carousel-pagination-button': true,
            active: indexBannerIndex === index,
          }"
          @click="goToSlide(index)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bannerData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      homeBannerList: [],
      currentIndex: 1,
      indexBannerIndex: 0,
      startX: 0,
      startY: 0,
      startTime: 0,
      dragging: false,
      threshold: 30,
      thresholdSpeed: 0.3,
      isIndex: false,
      videoIsPlay: false,
      videoPaused: true,
      autoplayInterval: null,
      lastWheelTime: 0,
      isTransitioning: false,
      wheelScrolling: false,
      lastWheelEventTime: 0,
      lastWheelDeltaX: 0,
      volume: 1, // 音量默认为1（最大）
      isMuted: false, // 默认不静音
      duration: 0, // 视频总时长
      currentTime: 0, // 当前播放时间
      progress: 0, // 进度条百分比
      volumeDragging: false, // 音量滑块是否正在拖拽
      progressDragging: false, // 进度条是否正在拖拽
      wasPlayingBeforeDrag: false, // 拖拽前是否正在播放
      startVolumeX: 0, // 音量滑块拖拽起始位置
      mouseTimer: null, // 鼠标悬停计时器
      controlsVisible: false, // 控制栏可见性状态，默认隐藏
    };
  },

  computed: {
    shouldShowBanner() {
      return (
        this.bannerData &&
        this.bannerData.some((item) => {
          if (item.img) return true;
          if (item.video) return true;
          return false;
        })
      );
    },
  },
  created() {
    this.isIndex = window.innerWidth < 961;
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  mounted() {
    this.$el.addEventListener("wheel", this.handleWheel, { passive: true });

    // 初始化音量滑块位置和进度条宽度
    this.$nextTick(() => {
      if (this.$refs.volumeThumb) {
        this.$refs.volumeThumb.style.left = `${this.volume * 100}%`;
      }
      if (this.$refs.volumeProgress) {
        this.$refs.volumeProgress.style.width = `${this.volume * 100}%`;
      }

      // 初始化视频高度适配
      this.adjustVideoHeight();
      window.addEventListener("resize", this.adjustVideoHeight);
    });

    // 移除全局鼠标移动监听器，避免在非视频区域触发控制栏
    // document.addEventListener('mousemove', this.handleMouseMove);
  },
  watch: {
    bannerData: {
      handler(newVal) {
        this.initializeSlides();
        this.startAutoplay();
      },
      deep: true,
      immediate: true,
    },
    volume: {
      handler(newVal) {
        // 当volume值变化时更新滑块位置和进度条宽度
        this.$nextTick(() => {
          if (this.$refs.volumeThumb && !this.volumeDragging) {
            this.$refs.volumeThumb.style.left = `${newVal * 100}%`;
          }
          if (this.$refs.volumeProgress && !this.volumeDragging) {
            this.$refs.volumeProgress.style.width = `${newVal * 100}%`;
          }
        });
      },
      immediate: true,
    },
  },
  filters: {
    formatTime(seconds) {
      const totalSeconds = Math.floor(seconds); // 向下取整
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      if (hours > 0) {
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
      } else {
        return `${minutes.toString().padStart(2, "0")}:${secs
          .toString()
          .padStart(2, "0")}`;
      }
    },
  },
  methods: {
    // 获取视频封面图片
    getVideoCoverImage(slide) {
      // 优先使用 store 中的 isEn 状态来判断当前语言
      const isEnglish = this.$store.state.isEn === 1;

      // 如果是英文状态，优先使用英文封面图
      if (isEnglish && slide.videoImageEn) {
        return slide.videoImageEn;
      }

      // 否则使用中文封面图，如果没有英文封面图或者不是英文状态
      return slide.videoImageCn || slide.videoImageEn || null;
    },

    handleMediaQueryChange(event) {
      this.isIndex = !event.matches;
      // 屏幕尺寸变化时重新调整视频高度
      this.$nextTick(() => {
        this.adjustVideoHeight();
      });
    },

    /**
     * 调整视频高度以适配不同屏幕尺寸
     */
    adjustVideoHeight() {
      const videos = document.querySelectorAll(".video");
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;

      // 根据屏幕尺寸设置视频高度
      let targetHeight;
      if (windowWidth <= 960) {
        // 移动端 - 基于宽度计算高度
        targetHeight = Math.min(windowWidth * 0.7, windowHeight * 0.5);
      } else if (windowWidth <= 1440) {
        // 平板/小屏桌面
        targetHeight = Math.min(windowHeight * 0.65, 620);
      } else {
        // 大屏桌面
        targetHeight = Math.min(windowHeight * 0.7, 700);
      }

      // 应用高度到所有视频元素
      videos.forEach((video) => {
        video.style.height = `${targetHeight}px`;
      });

      // 同时调整容器高度
      const wrappers = document.querySelectorAll(".banner-bg-wrapper");
      wrappers.forEach((wrapper) => {
        wrapper.style.height = `${targetHeight}px`;
      });
    },
    initializeSlides() {
      if (this.bannerData && this.bannerData.length > 0) {
        this.homeBannerList = [
          this.bannerData[this.bannerData.length - 1],
          ...this.bannerData,
          this.bannerData[0],
        ];
        this.indexBannerIndex = 0;
        this.$nextTick(() => {
          if (this.$refs.slides) {
            this.$refs.slides.style.transition = "none";
            this.$refs.slides.style.transform = `translateX(-100%)`;
          }
          setTimeout(this.checkFirstSlideForVideo, 500);
        });
      }
    },
    checkFirstSlideForVideo() {
      if (this.homeBannerList.length > 0 && this.homeBannerList[1]?.video) {
        this.$nextTick(() => {
          const video = this.$refs[`vueMiniPlayer1`]?.[0] || null;
          if (video) {
            // 先尝试静音自动播放，这是大多数浏览器允许的
            video.muted = true;
            this.isMuted = true;
            video
              .play()
              .then(() => {
                // 成功播放后更新状态
                this.videoIsPlay = true;
                this.controlsVisible = true; // 显示控制栏
                clearInterval(this.autoplayInterval);
              })
              .catch((error) => {
                // 如果自动播放失败，至少显示视频的第一帧
                video.currentTime = 0;
              });
          }
        });
      }
    },
    startDrag(event) {
      // 如果正在播放视频，则不允许拖拽
      if (this.videoIsPlay) return;

      this.startX = event.touches ? event.touches[0].clientX : event.clientX;
      this.startY = event.touches ? event.touches[0].clientY : event.clientY;
      this.startTime = new Date().getTime();
      this.dragging = true;

      document.addEventListener("mousemove", this.handleGlobalMouseMove);
      document.addEventListener("mouseup", this.handleGlobalMouseUp);
      document.addEventListener("touchmove", this.handleGlobalMouseMove, {
        passive: false,
      });
      document.addEventListener("touchend", this.handleGlobalMouseUp);
    },
    handleGlobalMouseMove(event) {
      if (this.dragging) {
        this.drag(event);
      }
    },
    drag(event) {
      // 如果正在播放视频，则不允许拖拽
      if (this.videoIsPlay) return;

      if (!this.dragging || this.isTransitioning) return;

      const currentX = event.touches ? event.touches[0].clientX : event.clientX;
      const currentY = event.touches ? event.touches[0].clientY : event.clientY;
      const deltaX = currentX - this.startX;
      const deltaY = currentY - this.startY;

      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        return;
      }

      // 阻止默认滚动行为，但仅在水平拖拽时
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        event.preventDefault();
      }

      if (this.$refs.slides) {
        const percentage =
          100 * this.currentIndex - (deltaX / window.innerWidth) * 100;
        this.$refs.slides.style.transform = `translateX(-${percentage}%)`;
      }
    },
    endDrag(event) {
      document.removeEventListener("mousemove", this.handleGlobalMouseMove);
      document.removeEventListener("mouseup", this.handleGlobalMouseUp);
      document.removeEventListener("touchmove", this.handleGlobalMouseMove);
      document.removeEventListener("touchend", this.handleGlobalMouseUp);

      if (!this.dragging || this.isTransitioning) return;

      const endX = event.changedTouches
        ? event.changedTouches[0].clientX
        : event.clientX;
      const endY = event.changedTouches
        ? event.changedTouches[0].clientY
        : event.clientY;
      const deltaX = endX - this.startX;
      const deltaY = endY - this.startY;
      const deltaTime = new Date().getTime() - this.startTime;

      this.dragging = false;

      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        this.updateSlideTransform();
        return;
      }

      const speed = Math.abs(deltaX) / deltaTime;

      if (
        (Math.abs(deltaX) > this.threshold || speed > this.thresholdSpeed) &&
        !this.videoIsPlay
      ) {
        if (deltaX > 0) {
          this.prevSlide();
        } else {
          this.nextSlide();
        }
      } else {
        this.updateSlideTransform();
      }

      setTimeout(() => {
        this.startAutoplay();
      }, 1000);
    },
    handleWheel(event) {
      // 如果正在播放视频，则不允许滚轮切换
      if (this.videoIsPlay) return;

      const now = Date.now();
      if (now - this.lastWheelTime < 300) {
        return;
      }
      this.lastWheelTime = now;

      if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
        return;
      }

      if (this.wheelScrolling || this.isTransitioning) {
        return;
      }

      const timeDiff = now - (this.lastWheelEventTime || 0);
      const deltaDiff = Math.abs(event.deltaX - (this.lastWheelDeltaX || 0));

      if (timeDiff < 100 && Math.abs(event.deltaX) < 20) {
        return;
      }

      this.lastWheelEventTime = now;
      this.lastWheelDeltaX = event.deltaX;

      event.preventDefault();

      this.wheelScrolling = true;

      clearInterval(this.autoplayInterval);

      if (Math.abs(event.deltaX) > 15) {
        if (event.deltaX > 0) {
          this.nextSlide();
        } else if (event.deltaX < 0) {
          this.prevSlide();
        }
      }

      setTimeout(() => {
        this.wheelScrolling = false;
        this.startAutoplay();
      }, 500);
    },
    nextSlide() {
      // 如果正在播放视频，则不允许自动切换
      if (this.videoIsPlay) return;

      if (this.isTransitioning) return;

      this.isTransitioning = true;
      this.$nextTick(() => {
        this.currentIndex++;
        this.enableTransition();
        this.updateSlideTransform();
        this.indexBannerIndex =
          (this.indexBannerIndex + 1) % (this.bannerData?.length || 1);

        if (this.currentIndex >= this.homeBannerList.length - 1) {
          setTimeout(() => {
            if (!this.$refs.slides) return;
            this.$refs.slides.style.transition = "none";
            this.currentIndex = 1;
            this.$refs.slides.style.transform = `translateX(-100%)`;
            this.$refs.slides.offsetHeight;
            this.isTransitioning = false;
          }, 500);
        } else {
          setTimeout(() => {
            this.isTransitioning = false;
          }, 500);
        }
      });
    },
    prevSlide() {
      // 如果正在播放视频，则不允许切换
      if (this.videoIsPlay) return;

      if (this.isTransitioning) return;

      this.isTransitioning = true;
      this.$nextTick(() => {
        this.currentIndex--;
        this.enableTransition();
        this.updateSlideTransform();
        this.indexBannerIndex =
          (this.indexBannerIndex - 1 + (this.bannerData?.length || 1)) %
          (this.bannerData?.length || 1);

        if (this.currentIndex <= 0) {
          setTimeout(() => {
            if (!this.$refs.slides) return;
            this.$refs.slides.style.transition = "none";
            this.currentIndex = this.homeBannerList.length - 2;
            this.$refs.slides.style.transform = `translateX(-${
              100 * (this.homeBannerList.length - 2)
            }%)`;
            this.$refs.slides.offsetHeight;
            this.isTransitioning = false;
          }, 500);
        } else {
          setTimeout(() => {
            this.isTransitioning = false;
          }, 500);
        }
      });
    },
    updateSlideTransform() {
      if (!this.$refs.slides) {
        console.warn("Slides element not found");
        this.isTransitioning = false;
        return;
      }
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    disableTransition() {
      if (!this.$refs.slides) {
        console.warn("Slides element not found");
        return;
      }
      this.$refs.slides.style.transition = `none`;
    },
    enableTransition() {
      if (!this.$refs.slides) {
        console.warn("Slides element not found");
        return;
      }
      this.$refs.slides.style.transition = `transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)`;
    },
    goToSlide(index) {
      if (this.isTransitioning) return;

      this.isTransitioning = true;
      clearInterval(this.autoplayInterval);
      this.currentIndex = index + 1;
      this.indexBannerIndex = index;
      this.enableTransition();
      this.updateSlideTransform();
      setTimeout(() => {
        this.isTransitioning = false;
        this.startAutoplay();
      }, 500);
    },
    startAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }
      this.autoplayInterval = setInterval(this.nextSlide, 4500);
    },
    toggleVideo() {
      const isVideo = this.homeBannerList[this.currentIndex]?.video;
      if (!isVideo) return;
      clearInterval(this.autoplayInterval);
      this.videoIsPlay = !this.videoIsPlay;

      // 当视频播放时，显示控制栏并启动计时器
      if (this.videoIsPlay) {
        this.controlsVisible = true;
        this.handleMouseMove(); // 启动计时器
      } else {
        // 视频暂停时，确保控制栏可见
        this.controlsVisible = true;
        if (this.mouseTimer) {
          clearTimeout(this.mouseTimer);
        }
      }

      this.$nextTick(() => {
        const video =
          this.$refs[`vueMiniPlayer${this.currentIndex}`]?.[0] || null;
        if (video) {
          this.videoIsPlay ? video.play().catch(console.error) : video.pause();
        }
      });
    },
    onVideoEnded() {
      clearInterval(this.autoplayInterval);
      this.videoIsPlay = false;
      // 视频结束时，确保控制栏始终可见
      this.controlsVisible = true;
      if (this.mouseTimer) {
        clearTimeout(this.mouseTimer); // 防止后续自动隐藏
      }
      this.$nextTick(() => {
        const video =
          this.$refs[`vueMiniPlayer${this.currentIndex}`]?.[0] || null;
        if (video) {
          video.pause(); // 明确暂停状态
        }
        setTimeout(() => {
          this.startAutoplay(); // 3秒后恢复轮播
        }, 3000);
      });
    },
    toggleMute() {
      this.isMuted = !this.isMuted;
      const video = this.$refs[`vueMiniPlayer${this.currentIndex}`]?.[0];
      if (video) {
        video.muted = this.isMuted;
      }
    },
    seekVideo(event) {
      const rect = event.currentTarget.getBoundingClientRect();
      const percent = (event.clientX - rect.left) / rect.width;
      const video = this.$refs[`vueMiniPlayer${this.currentIndex}`]?.[0];
      if (video) {
        video.currentTime = percent * video.duration;
      }
    },
    updateProgress() {
      const video = this.$refs[`vueMiniPlayer${this.currentIndex}`]?.[0];
      if (video) {
        this.currentTime = video.currentTime;
        this.progress = (video.currentTime / video.duration) * 100;
      }
    },

    // 进度条拖拽开始
    startProgressDrag(event) {
      // 防止事件冒泡
      event.stopPropagation();

      // 暂停视频播放
      this.wasPlayingBeforeDrag = this.videoIsPlay; // 记录拖拽前的播放状态
      if (this.videoIsPlay) {
        this.toggleVideo(); // 暂停视频
      }

      // 设置进度条拖拽状态
      this.progressDragging = true;

      // 绑定全局事件监听器
      document.addEventListener("mousemove", this.handleProgressMouseMove);
      document.addEventListener("mouseup", this.handleProgressMouseUp);
      document.addEventListener("touchmove", this.handleProgressMouseMove, {
        passive: false,
      });
      document.addEventListener("touchend", this.handleProgressMouseUp);

      // 立即更新进度
      this.handleProgressMouseMove(event);
    },

    // 进度条拖拽中
    handleProgressMouseMove(event) {
      // 如果没有在拖拽状态，则直接返回
      if (!this.progressDragging) return;

      // 阻止默认行为
      event.preventDefault();

      // 获取进度条元素的位置信息
      const progressBar = document.querySelector(".progress-bar");
      const rect = progressBar.getBoundingClientRect();

      // 计算鼠标相对于进度条的位置
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      let percent = (clientX - rect.left) / rect.width;

      // 限制百分比在0-1之间
      percent = Math.max(0, Math.min(1, percent));

      // 更新进度条显示
      this.progress = percent * 100;

      // 如果视频存在，则更新视频当前时间
      const video = this.$refs[`vueMiniPlayer${this.currentIndex}`]?.[0];
      if (video) {
        video.currentTime = percent * video.duration;
      }
    },

    // 进度条拖拽结束
    handleProgressMouseUp() {
      // 如果没有在拖拽状态，则直接返回
      if (!this.progressDragging) return;

      // 重置拖拽状态
      this.progressDragging = false;

      // 如果之前是在播放状态，则恢复播放
      if (this.wasPlayingBeforeDrag) {
        this.$nextTick(() => {
          this.toggleVideo(); // 恢复视频播放
        });
      }

      // 移除全局事件监听器
      document.removeEventListener("mousemove", this.handleProgressMouseMove);
      document.removeEventListener("mouseup", this.handleProgressMouseUp);
      document.removeEventListener("touchmove", this.handleProgressMouseMove);
      document.removeEventListener("touchend", this.handleProgressMouseUp);
    },

    // 新增：点击音量滑块调整音量
    adjustVolumeByClick(event) {
      if (this.volumeDragging) return;

      const rect = this.$refs.volumeSlider.getBoundingClientRect();
      const percent = Math.max(
        0,
        Math.min(1, (event.clientX - rect.left) / rect.width)
      );
      this.volume = percent;
      this.updateVolume();

      // 更新滑块位置和进度条宽度
      if (this.$refs.volumeThumb) {
        this.$refs.volumeThumb.style.left = `${percent * 100}%`;
      }
      if (this.$refs.volumeProgress) {
        this.$refs.volumeProgress.style.width = `${percent * 100}%`;
      }
    },

    // 新增：音量滑块拖拽开始
    startVolumeDrag(event) {
      this.volumeDragging = true;
      this.startVolumeX = event.touches
        ? event.touches[0].clientX
        : event.clientX;

      // 移除过渡效果以便实时拖拽
      if (this.$refs.volumeThumb) {
        this.$refs.volumeThumb.style.transition = "none";
      }
      if (this.$refs.volumeProgress) {
        this.$refs.volumeProgress.style.transition = "none";
      }

      // 绑定全局事件监听器
      document.addEventListener("mousemove", this.handleVolumeMouseMove);
      document.addEventListener("mouseup", this.handleVolumeMouseUp);
      document.addEventListener("touchmove", this.handleVolumeMouseMove, {
        passive: false,
      });
      document.addEventListener("touchend", this.handleVolumeMouseUp);
    },

    // 新增：音量滑块拖拽中
    handleVolumeMouseMove(event) {
      if (!this.volumeDragging) return;

      event.preventDefault();

      const currentX = event.touches ? event.touches[0].clientX : event.clientX;
      const rect = this.$refs.volumeSlider.getBoundingClientRect();
      const percent = Math.max(
        0,
        Math.min(1, (currentX - rect.left) / rect.width)
      );
      this.volume = percent;

      // 更新滑块位置和进度条宽度
      if (this.$refs.volumeThumb) {
        this.$refs.volumeThumb.style.left = `${percent * 100}%`;
      }
      if (this.$refs.volumeProgress) {
        this.$refs.volumeProgress.style.width = `${percent * 100}%`;
      }

      this.updateVolume();
    },

    // 新增：音量滑块拖拽结束
    handleVolumeMouseUp() {
      if (!this.volumeDragging) return;
      this.volumeDragging = false;

      // 恢复过渡效果
      if (this.$refs.volumeThumb) {
        this.$refs.volumeThumb.style.transition = "left 0.2s ease";
      }
      if (this.$refs.volumeProgress) {
        this.$refs.volumeProgress.style.transition = "width 0.2s ease";
      }

      // 移除全局事件监听器
      document.removeEventListener("mousemove", this.handleVolumeMouseMove);
      document.removeEventListener("mouseup", this.handleVolumeMouseUp);
      document.removeEventListener("touchmove", this.handleVolumeMouseMove);
      document.removeEventListener("touchend", this.handleVolumeMouseUp);
    },

    // 更新音量
    updateVolume() {
      const video = this.$refs[`vueMiniPlayer${this.currentIndex}`]?.[0];
      if (video) {
        video.volume = this.volume;
      }
    },

    // 鼠标移动事件处理
    handleMouseMove() {
      // 显示控制栏
      this.controlsVisible = true;

      // 清除之前的计时器
      if (this.mouseTimer) {
        clearTimeout(this.mouseTimer);
      }

      // 如果视频正在播放，设置5秒后隐藏控制栏
      if (this.videoIsPlay) {
        this.mouseTimer = setTimeout(() => {
          this.controlsVisible = false;
        }, 5000);
      }
    },

    // 鼠标离开容器时显示控制栏
    handleMouseLeave() {
      // 清除计时器
      if (this.mouseTimer) {
        clearTimeout(this.mouseTimer);
      }
      // 如果视频在播放，隐藏控制栏
      if (this.videoIsPlay) {
        this.controlsVisible = false;
      }
    },

    // 视频点击事件处理
    handleVideoClick() {
      // 如果视频正在播放，点击时显示控制栏
      if (this.videoIsPlay) {
        this.handleMouseMove(); // 复用鼠标移动事件处理函数
      }
    },

    // 触摸开始事件处理（移动端）
    handleTouchStart() {
      // 显示控制栏
      this.controlsVisible = true;

      // 清除之前的计时器
      if (this.mouseTimer) {
        clearTimeout(this.mouseTimer);
      }
    },

    // 触摸移动事件处理（移动端）
    handleTouchMove() {
      // 显示控制栏
      this.controlsVisible = true;

      // 清除之前的计时器
      if (this.mouseTimer) {
        clearTimeout(this.mouseTimer);
      }
    },

    // 触摸结束事件处理（移动端）
    handleTouchEnd() {
      // 如果视频正在播放，设置5秒后隐藏控制栏
      if (this.videoIsPlay) {
        // 清除之前的计时器
        if (this.mouseTimer) {
          clearTimeout(this.mouseTimer);
        }

        this.mouseTimer = setTimeout(() => {
          this.controlsVisible = false;
        }, 5000);
      }
    },
  },
  beforeDestroy() {
    // 移除全局事件监听器
    this.$el.removeEventListener("wheel", this.handleWheel);
    // 注意：我们已经移除了这个全局监听器，因此不需要清理
    // document.removeEventListener('mousemove', this.handleMouseMove);

    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
    this.mediaQuery.removeListener(this.handleMediaQueryChange);

    // 清理音量滑块相关的事件监听器
    document.removeEventListener("mousemove", this.handleVolumeMouseMove);
    document.removeEventListener("mouseup", this.handleVolumeMouseUp);
    document.removeEventListener("touchmove", this.handleVolumeMouseMove);
    document.removeEventListener("touchend", this.handleVolumeMouseUp);

    // 清理进度条相关的事件监听器
    document.removeEventListener("mousemove", this.handleProgressMouseMove);
    document.removeEventListener("mouseup", this.handleProgressMouseUp);
    document.removeEventListener("touchmove", this.handleProgressMouseMove);
    document.removeEventListener("touchend", this.handleProgressMouseUp);
  },
};
</script>

<style scoped>
.index-banner-home {
  position: relative;
  max-height: 700px; /* 最大高度限制 */
}
.carousel {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #000;
}
.banner-bg-wrapper {
  position: relative;
  display: block;
  width: 100%;
  overflow: hidden;
  height: 100%;
}
.video {
  width: 100%;
  object-fit: contain;
  margin: auto;
  display: block;
  /* 高度适配关键属性 */
  max-height: 700px; /* 最大高度限制 */
}
.video-click {
  position: absolute;
  left: 45px;
  bottom: 25px;
  z-index: 99;
  width: 100px;
  background-color: rgba(240, 6, 6, 0);
  height: 40px;
  text-align: left;
  cursor: pointer;
}
.video-click-img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
.overlay-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  background-color: #000;
  z-index: 1;
}
.imgShow {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.imgShow img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.carousel-slides {
  position: relative;
  display: flex;
  width: 100%;
  transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  transform: translateX(-100%);
}
.carousel-slides .pc {
  width: 100%;
  max-height: 700px;
  object-fit: cover;
}
.carousel-slides .wap {
  display: none;
  object-fit: cover;
}
.home-swiper-pagination {
  position: relative;
  width: 1400px;
  margin: 0 auto;
}
.carousel-slide {
  position: relative;
  flex: 0 0 100%;
  min-width: 100%;
  text-align: left;
}
.carousel-pagination {
  position: absolute;
  right: -20px;
  bottom: 40px;
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
}
.carousel-pagination-button {
  margin: auto 4px !important;
  opacity: 1;
  width: 20px;
  height: 4px;
  background: url(../../assets/diandian_grey.png) no-repeat center;
  background-size: contain;
  cursor: pointer;
  position: relative;
}

.carousel-pagination-button::before {
  content: "";
  position: absolute;
  top: -20px;
  left: -6px;
  right: -6px;
  bottom: -20px;
  cursor: pointer;
}

.carousel-pagination-button.active {
  background: url(../../assets/diandian_highllight.png) no-repeat center;
}

.carousel-pagination-button.active::before {
  content: "";
  position: absolute;
  top: -20px;
  left: -6px;
  right: -6px;
  bottom: -20px;
  cursor: pointer;
}
.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: #000;
  border: none;
  cursor: pointer;
  z-index: 10;
}
/* 视频控制样式 */
.video-box {
  width: 100%;
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  z-index: 10;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
}
.video-controls {
  padding: 0 20px;
  width: 1440px;
  margin: 0 auto;
  color: white;
}

.progress-container {
  flex: 1;
  margin-right: 10px;
}

.progress-bar {
  width: 100%;
  height: 3px;
  background: #fff;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
}

.progress {
  height: 3px;
  background: #ffc592;
  border-radius: 4px;
  width: 0%;
}

.time-display {
  font-size: 12px;
  color: white;
  margin-right: 14px;
  line-height: 24px;
}

.volume-control {
  display: flex;
  align-items: center;
  margin: 12px 0 10px -10px;
}

.mute-button {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 14px;
}
.mute-button img {
  width: 24px;
  height: 24px;
}

.volume-slider {
  width: 80px;
  height: 4px;
  margin-left: 10px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;
}

.play-pause-control {
  display: flex;
  align-items: center;
}

.play-pause-button {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 4px;
  padding: 6px;
}

.play-pause-button img {
  width: 26px;
  height: 26px;
}

.custom-volume-slider {
  width: 80px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  position: relative;
  cursor: pointer;
}

.volume-track {
  width: 100%;
  height: 2px;
  background: #fff;
  border-radius: 2px;
}

.volume-progress {
  height: 2px;
  background: #ffc592;
  border-radius: 2px;
  width: 0%;
  position: absolute;
  top: 0;
  left: 0;
}

.volume-thumb {
  width: 8px;
  height: 8px;
  background: #ffc592;
  border-radius: 50%;
  position: absolute;
  top: -3px;
  left: 0;
  transform: translateX(-50%);
  z-index: 1;
}
@media (max-width: 1600px) {
  .home-swiper-pagination {
    position: relative;
    width: 92%;
    margin: 0 auto;
  }
  .video-box {
    bottom: 2px;
  }
  .video-controls {
    padding: 0 20px;
    width: 92%;
    color: white;
    z-index: 10;
  }

  .carousel-pagination {
    right: 0px;
  }
}
@media (max-width: 1440px) {
  .home-swiper-pagination {
    position: relative;
    width: 92%;
    margin: 0 auto;
  }
  .video-controls {
    padding: 0 20px;
    width: 90%;
    color: white;
    z-index: 10;
  }
  .carousel-pagination {
    right: -30px;
  }
  .index-banner-home {
    max-height: 620px;
    width: 99.99%;
    margin: 0 auto;
    height: 70vh;
  }

  .carousel-slides .pc {
    max-height: 620px;
    height: 70vh;
  }
  .banner-bg-wrapper {
    position: relative;
    display: block;
    width: 100%;
    overflow: hidden;
    height: 70vh;
      max-height: 620px;
  }
  .video {
    width: 100%;
    object-fit: contain;
    margin: auto;
    display: block;
    height: 70vh;
    max-height: 620px;
    background-color: #000;
  }
  .video-click {
    position: absolute;
    left: 45px;
    bottom: 25px;
    z-index: 99;
    width: 100px;
    background-color: rgba(240, 6, 6, 0);
    height: 40px;
    background-color: rgba(240, 6, 6, 0);
    height: 40px;
    cursor: pointer;
  }
}
@media (max-width: 1240px) {
  .carousel-slides .pc {
    width: 100%;
    max-height: 500px;
    object-fit: cover;
  }
  .video-box {
    bottom: 0px;
  }
  .time-display {
    font-size: 12px;
    color: white;
    margin-right: 24px;
    line-height: 24px;
  }
  .mute-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 10px;
  }
  .play-pause-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 4px;
    padding: 6px;
  }
  .volume-control {
    margin-top: 10px;
  }
  .home-swiper-pagination {
    position: relative;
    width: 90%;
    margin: 0 auto;
  }
  .video-controls {
    padding: 0 10px;
    width: 92%;
    color: white;
    z-index: 10;
  }
}
@media (max-width: 1100px) {
  .home-swiper-pagination {
    position: relative;
    width: 90%;
    margin: 0 auto;
  }
  .time-display {
    font-size: 12px;
    color: white;
    margin-right: 24px;
    line-height: 24px;
  }
  .mute-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 10px;
  }
  .play-pause-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 4px;
    padding: 6px;
  }
  .volume-control {
    margin-top: 10px;
  }
  .video-controls {
    padding: 0 10px;
    width: 92%;
    color: white;
    z-index: 10;
  }
}
@media (max-width: 960px) {
  .carousel-slides .pc {
    display: none;
  }
  .time-display {
    font-size: 10px;
    color: white;
    margin-right: 24px;
    line-height: 24px;
  }
  .mute-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 4px;
  }
  .play-pause-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 4px;
    padding: 6px;
  }
  .video-controls {
    padding: 0 20px;
    width: 95%;
    color: white;
    z-index: 10;
  }
  .volume-control {
    margin-top: 5px;
  }
  .carousel-slides .wap {
    display: block;
    min-height: calc(100vw * 0.7);
    max-height: calc(100vh * 0.5);
    width: 100%;
    object-fit: cover;
  }
  .index-banner-home {
    min-height: calc(100vw * 0.7);
    height: auto;
  }
  .banner-bg-wrapper {
    position: relative;
    display: block;
    width: 100%;
    min-height: calc(100vw * 0.7);
    max-height: calc(100vh * 0.5);
    overflow: hidden;
  }
  .video {
    width: 100%;
    min-height: calc(100vw * 0.7);
    max-height: calc(100vh * 0.5);
    object-fit: contain;
    margin: auto;
    display: block;
    background-color: #000;
  }
  .video-click {
    position: absolute;
    left: 5px;
    bottom: 5px;
    z-index: 99;
    width: 100px;
    background-color: rgba(240, 6, 6, 0);
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .carousel-pagination-button {
    margin: auto 4px !important;
    opacity: 1;
    width: 16px;
    height: 3px;
    background: url(../../assets/diandian_grey.png) no-repeat center;
    background-size: contain;
    cursor: pointer;
    position: relative;
  }

  .carousel-pagination-button::before {
    content: "";
    position: absolute;
    top: -20px;
    left: -6px;
    right: -6px;
    bottom: -20px;
    cursor: pointer;
  }
  .carousel-pagination {
    position: absolute;
    right: 0;
    bottom: 20px;
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;
  }
}
</style>